import React, { createContext, useContext, useState } from 'react'

import { Drawer } from 'antd'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'

import InternshipFilesManager from '../../Components/shared/FilesManager/InternshipFilesManager/InternshipFilesManager'
import InternshipFileModal from '../Forms/InternshipFileModal'
import { GlobalContext } from '../GlobalProvider'

export const InternshipDocumentsDrawerContext = createContext()

export const DEFAULT_STATE = { data: null, callback: null, readOnly: false }

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const InternshipDocumentsDrawer = ({ children, t }) => {
  const { isReadOnly } = useContext(GlobalContext)

  const [handler, setHandler] = useState(DEFAULT_STATE)

  return (
    <>
      <InternshipDocumentsDrawerContext.Provider value={{ setHandler }}>
        {children}
      </InternshipDocumentsDrawerContext.Provider>
      <Drawer
        title={t('internship_files_drawer.title')}
        width='650px'
        onClose={() => setHandler(DEFAULT_STATE)}
        visible={!!handler.data}
        zIndex={5000}
        destroyOnClose
      >
        <InternshipFileModal>
          <InternshipFilesManager internship={handler.data} readOnly={isReadOnly || handler.readOnly} />
        </InternshipFileModal>
      </Drawer>
    </>
  )
}

export default connect(mapStateToProps)(InternshipDocumentsDrawer)
